<template>
  <VideosTab
    :product="slug"
    :categories-videos="categoriesVideos"
    @toggle-view-more="toggleViewMore"
    @play-video="$emit('play-video', $event)"
  />
</template>

<script lang="ts" setup>
import { useSeo } from '~/composables/useSeo'
import VideosTab from '~/components/market-insights/VideosTab.vue'

/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  slug: string
  categoriesVideos: string[] | null
}>()

defineEmits<{
  'play-video': [value: string]
}>()

/*-------------------------------------
  State
-------------------------------------*/
const isViewMoreActive = useState<boolean>('isViewMoreActive', () => false)

/*-------------------------------------
  Methods
-------------------------------------*/
const toggleViewMore = (isActive: boolean) => {
  isViewMoreActive.value = isActive
}

/*-------------------------------------
  Lifecycle
-------------------------------------*/
onUnmounted(() => {
  isViewMoreActive.value = false
})

/*-------------------------------------
  SEO
-------------------------------------*/
const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: 'Lithium Market Videos',
  description:
    "Benchmark's lithium experts provide video content dissecting the evolving market. Access lithium price insight, data, forecasts and sustainability analysis.",
})
useHead(seo)
</script>
